export const FILTERS_CONTAINER_HEIGHT = 125;
